import { KeyValue } from "@angular/common";

export class KeyValueSort {
  public static readonly valueAscOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return a.value.localeCompare(b.value);
  }
}
